import { getStaticProps as pageGetStaticProps } from '@/pages/blog/strona/[page]'
export { default, getStaticPaths } from '@/pages/blog/strona/[page]'

export function getStaticProps(ctx: any) {
  return pageGetStaticProps({ ...ctx, locale: 'en' })
}
